import { render, staticRenderFns } from "./PiazzollaArticle.vue?vue&type=template&id=66de42ec&"
import script from "./PiazzollaArticle.vue?vue&type=script&lang=js&"
export * from "./PiazzollaArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports